import { render } from "./SuperAdminDashboard.vue?vue&type=template&id=23e1936d&scoped=true"
import script from "./SuperAdminDashboard.vue?vue&type=script&lang=js"
export * from "./SuperAdminDashboard.vue?vue&type=script&lang=js"

import "./SuperAdminDashboard.vue?vue&type=style&index=0&id=23e1936d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e1936d"]])

export default __exports__